import { useLang } from "../context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0B1F3A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-12 gap-8 mb-12">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-2">
              <svg width="22" height="22" viewBox="0 0 22 22">
                <rect x="1" y="1" width="20" height="20" fill="none" stroke="#D4AF37" strokeWidth="1.5" />
                <rect x="6" y="6" width="10" height="10" fill="#D4AF37" />
              </svg>
              <span className="font-display text-base font-semibold tracking-tight">
                MaxSolution<sup className="text-[8px] ml-0.5">™</sup>
              </span>
            </div>
            <p className="mt-6 font-display text-2xl lg:text-3xl font-light leading-tight max-w-md">
              {t.footer.tagline}
            </p>
            <p className="mt-4 text-sm text-white/60 max-w-md leading-relaxed">
              Indonesia's Digital Infrastructure Company™ — designing, building and operating Digital Operating Systems for modern organizations.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-2 lg:col-start-8">
            <div className="overline text-[#D4AF37]">{t.footer.solutions}</div>
            <ul className="mt-5 space-y-3 text-sm text-white/80">
              <li><a href="#solutions" className="hover:text-[#D4AF37] transition-colors">Experience OS™</a></li>
              <li><a href="#solutions" className="hover:text-[#D4AF37] transition-colors">Workforce OS™</a></li>
              <li><a href="#solutions" className="hover:text-[#D4AF37] transition-colors">Operations OS™</a></li>
              <li><a href="#solutions" className="hover:text-[#D4AF37] transition-colors">Commercial OS™</a></li>
              <li><a href="#solutions" className="hover:text-[#D4AF37] transition-colors">Data Intelligence OS™</a></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="overline text-[#D4AF37]">{t.footer.company}</div>
            <ul className="mt-5 space-y-3 text-sm text-white/80">
              <li><a href="#framework" className="hover:text-[#D4AF37] transition-colors">{t.footer.links.framework}</a></li>
              <li><a href="#ecosystem" className="hover:text-[#D4AF37] transition-colors">{t.footer.links.ecosystem}</a></li>
              <li><a href="#services" className="hover:text-[#D4AF37] transition-colors">{t.footer.links.services}</a></li>
              <li><a href="#insights" className="hover:text-[#D4AF37] transition-colors">{t.footer.links.insights}</a></li>
              <li><a href="#contact" className="hover:text-[#D4AF37] transition-colors">{t.footer.links.contact}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 pt-6 flex flex-wrap items-center justify-between gap-4">
          <div className="text-xs text-white/60">
            <span className="text-white font-semibold">{t.footer.legal}</span> · © {new Date().getFullYear()} · {t.footer.rights}
          </div>
          <div className="text-[10px] tracking-[0.25em] text-[#D4AF37] uppercase font-semibold">
            From Operations to Intelligence™
          </div>
        </div>
      </div>
    </footer>
  );
};
